"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDistanceFormated = void 0;
function getDistanceFormated(distance) {
    if (distance < 1000) {
        return `${Math.round(distance)} м`;
    }
    const distanceKm = distance / 1000;
    if (distance > 100000) {
        return `${Math.round(distanceKm)} км`;
    }
    return `${distanceKm.toFixed(1)} км`;
}
exports.getDistanceFormated = getDistanceFormated;
//# sourceMappingURL=getDistanceFormated.js.map